import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BankService {

  private bankaMap: { [key: string]: string } = {
    '2400': 'Erste&Steiermärkische Bank',
    '2480': 'Raiffeisenbank',
    '2500': 'Addiko Bank',
    '2390': 'Hrvatska poštanska banka (HPB)',
    '2340': 'Privredna banka Zagreb (PBZ)',
    '2360': 'Zagrebačka banka',
    '2471': 'OTP banka',
    '2411': 'Nova hrvatska banka',
    '2485': 'Partner banka'
  };

  prepoznajBanku(iban: string): string {
    if (!iban || !iban.startsWith('HR') || iban.length < 11) {
      return 'Nepoznat IBAN format';
    }

    const oznaka = iban.substring(4, 8); // pozicije 5-8
    return this.bankaMap[oznaka] || 'Nepoznata banka';
  }
}
